import e from "ky";
import { passportAuth as t } from "./modules/auth.js";
import { addRequestId as r } from "./modules/request-id.js";
const d = e.extend({
  credentials: "include",
  redirect: "error",
  headers: {
    "x-requested-with": "XMLHttpRequest",
    "content-type": "application/json;charset=UTF-8"
  },
  timeout: 25e3,
  hooks: {
    beforeRequest: [r],
    afterResponse: [t]
  }
});
export {
  d as dsFetch
};
